import { Component, OnInit } from '@angular/core';
import { LandingDTOModel} from "../../bpg-common/services/data.services";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BpgExpensesService } from '../../bpg-expenses/bpg-expenses.service';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';

@Component({
  selector: 'app-claim-expense-approval',
  templateUrl: './claim-expense-approval.component.html',
  styleUrls: ['./claim-expense-approval.component.css']
})
export class ClaimExpenseApprovalComponent implements OnInit {
  selectedExpenseDetails: any = JSON.parse(sessionStorage.getItem('expenseDetails'));
  claimExpenseApprove : any;
  approved = false;
  rejected = false;
  expenseKeyList:any;
  iconButtonVisible:any;
  expenseDetails:any;
  awsUrls: any;
  awsFullUrls1: any;
  awsFullUrls2: any;
  id :any;
  userIdDto : any;
  userRoleDetails: any;
  isBpgLeadAdmin = false;
 
  landingData: any;
  approverComment = "";
  adminId: any  = localStorage.getItem('adminId');
  alertSuccessApproved: boolean;
  alertSuccessRejected: boolean;
  invalidCommentForApprove: boolean;
  invalidCommentForReject: boolean;
  method: string;
  msg1: string;
  param: string;
  type: string;
  landingDTOModel:LandingDTOModel = new LandingDTOModel();
  loginData = JSON.parse(localStorage.getItem('loginData'));
  expenseStatus : any;
  alertCommentForTotalExpense:boolean;
  buttonUsed:any;
  loginDetails: any  = JSON.parse(localStorage.getItem("loginData"));
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;
  isBpgAdmin = false;
  isbpgLeadAdmin = false;
  isNaacAdmin = false;
  expenseListConstant = 'expense-list';
  dataTargetConstant = 'data-target';
  dataToggleConstant = 'data-toggle';
  constructor(
    private readonly location: Location,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    private readonly router : Router,
    private readonly bpgEventsService : BpgEventsService,
    private readonly bpgExpensesService : BpgExpensesService,
    private readonly route: ActivatedRoute,
    private readonly environment : EnvironmentConfiguration,
    private readonly bpgCommonService :BpgCommonService) { }

  ngOnInit() {
    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
   if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
      }
    }
     
    window.scrollTo(0, 0)

    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isBpgAdmin = true
    }
    if(localStorage.getItem('isNaacAdmin') === 'true')
    {
      this.isNaacAdmin = true
    }
    if(this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && this.adminId !== "4" && !this.isBpgAdmin && !this.isbpgLeadAdmin && !this.isNaacAdmin)
    {
      this.router.navigate(['/site-home']);
    }

   sessionStorage.removeItem("MembershipData");
    this.spinnerService.show();
      // newly added
      const paramExists = this.route.snapshot.paramMap.has('id');
      if(paramExists){
        this.route.params.subscribe((params) => {
          // bring expense data and set it here
          if(params.id!=null && params.id!=undefined){
            this.bpgExpensesService.getExpenseById(params.id).subscribe(data=>{
              if(data!=null){
               this.selectedExpenseDetails = data;
               this.afterOnInitMethod();
              //  this.buildForms();
              }
           },err => {
             this.spinnerService.hide();
             if(err.value.statusText === ConstantValues.unknownError){
               this.timeOutError = true;
             }
           });
          }
        });
      }else{
        this.afterOnInitMethod();
      }

  
  // newly added ends
    
 
   
  }

  public afterOnInitMethod(){
    this.expenseDetails =
    {
      'awsUrl': '',
      'category': 'EXPENSE_DOC',
      'expenseDoc1':`${this.selectedExpenseDetails.expenseId}/${this.selectedExpenseDetails.supportingDoc1}`,
      'expenseDoc2':`${this.selectedExpenseDetails.expenseId}/${this.selectedExpenseDetails.supportingDoc2}`,
    }

    if (this.adminId === "1" || this.adminId === "2" || this.isbpgLeadAdmin || this.adminId === "4" || this.isNaacAdmin) {
      this.landingData = this.bpgEventsService.landingDto1();
    }
   
    this.userIdDto = { 
      "userId": this.loginDetails['userId'],
      "filter": "forAdminRoleCheck",
      "chapterId": this.selectedExpenseDetails['chapterId'] };

    this.bpgCommonService.getUserRoleDetails(this.userIdDto).subscribe(data => {
      this.userRoleDetails = data;
      for(const userRole of this.userRoleDetails.adminId){
        if(userRole === 2){
          this.isBpgLeadAdmin = true;
        }
      }
      
    })

    if(this.selectedExpenseDetails.supportingDoc1 != null || this.selectedExpenseDetails.supportingDoc2 != null){
      
      this.bpgEventsService.getAwsUrlsApi(this.expenseDetails).subscribe(data => {
         this.awsUrls = data;
         this.awsFullUrls1 = this.awsUrls.expenseDoc1;
         this.awsFullUrls2 = this.awsUrls.expenseDoc2;
        });
     
      }
   

    if(this.selectedExpenseDetails.isEventExpense === true){
      this.selectedExpenseDetails.isEventExpense = "Yes";
    }else{
      this.selectedExpenseDetails.isEventExpense = "No";
    }
    setTimeout(function() {  
      this.spinnerService.hide();
    }.bind(this), 2000);   
    this.iconButtonVisible = sessionStorage.getItem(this.expenseKeyList);
    this.adminId = localStorage.getItem('adminId');
    this.expenseStatus = this.selectedExpenseDetails.expenseStatus;
  }

  public goBack(){  
    sessionStorage.setItem(this.buttonUsed, "BACK");  
    this.location.back();
  }

  /** to download attachments
   * @class ClaimExpenseApprovalComponent
   * @method downloadAttachments1
   * 
   */
  downloadAttachments1(urls,val) {
    const extension = urls.substring(urls.lastIndexOf('.')+1);
    const link = document.getElementById(val);

    link.setAttribute('href', urls);
    link.setAttribute('download', urls);
    if(extension === 'pdf'){
       link.setAttribute('target', '_blank');
      }
    }
    
     /** To change the expense status based on Approval or Rejection
      * @class ClaimExpenseApprovalComponent
      * @method changeExpenseStatus
      */
    changeExpenseStatus(type) {
      this.timeOutError = false;
      switch (type) {
       
       
      case 'APPROVED':
      /*for second level of approval*/
      this.landingDTOModel.expenseId = this.selectedExpenseDetails.expenseId;
      this.landingDTOModel.superAdminApprovalComment = this.approverComment;
      this.landingDTOModel.superAdminApprovedBy = this.loginData.userId;
      this.landingDTOModel.expenseStatus = 'APPROVED';
        this.alertSuccessApproved = true;
      setTimeout(function () {
        this.alertSuccessApproved = false;
      }.bind(this), 6000);
      setTimeout(function () {
        this.router.navigate([this.expenseListConstant]);
      }.bind(this), 6000);
      break;
         
      case 'REJECTED':
      /*for second level of rejection*/
      this.landingDTOModel.expenseId = this.selectedExpenseDetails.expenseId;
      this.landingDTOModel.superAdminApprovalComment = this.approverComment;
      this.landingDTOModel.superAdminApprovedBy = this.loginData.userId;
      this.landingDTOModel.expenseStatus = 'REJECTED';
         this.alertSuccessRejected = true;
         setTimeout(function () {
          this.alertSuccessRejected = false;
        }.bind(this), 6000);
        setTimeout(function () {
          this.router.navigate([this.expenseListConstant]);
        }.bind(this), 6000);
        break;
  
    }
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    },500);
    this.bpgExpensesService.updateExpenseStatus(this.landingDTOModel).subscribe(_data => {
      
    }, err => {
      this.spinnerService.hide();
      if(err.value.statusText === ConstantValues.unknownError){
                  this.timeOutError = true;
                }
    });
    
  }
  
   /** To select approve with confirmation
 * @class ClaimExpenseApprovalComponent
 * @method approveClick
 */
approveClick(expenseStatus) {
  this.invalidCommentForReject = false;  
   if(this.approverComment.length === 0)
  {
    this.invalidCommentForApprove = true;  
    this.alertCommentForTotalExpense = false;
    document.getElementById('approveBtnClick').removeAttribute(this.dataTargetConstant);
    document.getElementById('approveBtnClick').removeAttribute(this.dataToggleConstant);
  }
  else if(this.selectedExpenseDetails.remainingBudgetChapter < this.selectedExpenseDetails.totalExpense ){
    this.alertCommentForTotalExpense = true;
    this.invalidCommentForApprove = false; 
    document.getElementById('approveBtnClick').removeAttribute(this.dataTargetConstant);
    document.getElementById('approveBtnClick').removeAttribute(this.dataToggleConstant); 
  }
  else{
    switch(expenseStatus){
      case 'SUBMITTED':
      case 'REJECTED':
      this.param = "APPROVED";
      break;

      case 'APPROVED': 
        this.param = "APPROVED";
        break;

    }
         
     document.getElementById('approveBtnClick').setAttribute(this.dataTargetConstant,'#myModal');
     document.getElementById('approveBtnClick').setAttribute(this.dataToggleConstant,'modal');
    this.invalidCommentForApprove = false;
    this.alertCommentForTotalExpense = false;
    this.method = "changeExpenseStatus";
    this.msg1 = " Are you sure you want to approve this expense claim ? ";
}
}

 /** To select reject with confirmation
 * @class ClaimExpenseApprovalComponent
 * @method rejectClick
 */
  rejectClick(expenseStatus) {
    this.invalidCommentForApprove = false;
    if (this.approverComment.length === 0) {
      this.invalidCommentForReject = true;
      document.getElementById('rejectBtnClick').removeAttribute(this.dataTargetConstant);
      document.getElementById('rejectBtnClick').removeAttribute(this.dataToggleConstant);
      return;
    }

    switch (expenseStatus) {
      case 'SUBMITTED':
      case 'REJECTED':
        this.param = "REJECTED";
        break;
      case 'APPROVED':
        this.param = "REJECTED";
        break;
    }

    this.invalidCommentForReject = false;
    document.getElementById('rejectBtnClick').setAttribute(this.dataTargetConstant, '#myModal');
    document.getElementById('rejectBtnClick').setAttribute(this.dataToggleConstant, 'modal');
    this.method = "changeExpenseStatus";
    this.msg1 = " Are you sure you want to reject this expense claim ? ";
  }
}
